export default __webpack_public_path__ + "static/media/totem2.88764d3d.svg";